import Icon from '../Icon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMobileMenu } from '../../Actions/Navigation.action';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { translate } from '../../Services/translation';
import { RootState } from '../../reducers';
import { setLoginModalOpen } from '../../Actions/Login.action';
import { toggleInputActive } from '../../Actions/QuickSearch.action';
import { setShowMiniCart } from '../../Actions/Cart.action';

const StyledNavMobileTrigger = styled(Icon)`
  cursor: pointer;
  color: ${getColor('grey', 900)};
`;

const NavigationMobileTrigger = () => {
  const dispatch = useDispatch();
  const mobileMenuOpen = useSelector((state: RootState) => state.navigation.mobileMenuOpen);

  return (
    <div
      className='flex flex-col items-center gap-2'
      onClick={() => {
        dispatch(toggleMobileMenu(!mobileMenuOpen))
        dispatch(toggleInputActive(false))
        dispatch(setLoginModalOpen(false))
        dispatch(setShowMiniCart(false))
      }}>
      <StyledNavMobileTrigger
        name="menu"


        className='icon--larger'
      ></StyledNavMobileTrigger>
      <span className="text-white text-[1.2rem]">{translate('general.products')}</span>

    </div>
  );
};

export default NavigationMobileTrigger;
